// src/components/AuthWrapper.tsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { fetchCreditBalance } from "store/paymentSlice";
import { RootState, AppDispatch } from "store";

const AuthWrapper: React.FC = () => {
  // Remove props interface
  const dispatch = useDispatch<AppDispatch>();
  const { loggedIn } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchCreditBalance());

      // Optional: Periodic refresh
      const intervalId = setInterval(() => {
        dispatch(fetchCreditBalance());
      }, 60000);

      return () => clearInterval(intervalId);
    }
  }, [dispatch, loggedIn]);

  return <Outlet />; // Use Outlet instead of children
};

export default AuthWrapper;
